@if (bigScreenMode && isDesktopDataLoaded) {
<ion-grid class="sis-grid" [style.min-height]="gridMinHeight + 'px'" #desktopGrid>
  @if (showHeader) {
  <ion-row class="sis-header" [style]="{ 'background': config?.headerColor }">
    <ion-col>
      <ion-img [src]="headerImage" class="sis-header-image"></ion-img>
      @if (showTimestamp) {
      <span class="sis-header-timestamp" [ngStyle]="{ 'color': config?.tenantTitleColor}"
        >{{timestamp | date : 'dd.MM.yyyy HH:mm'}}</span
      >
      }
    </ion-col>
  </ion-row>
  } @for (tenantMapping of webReportDesktopItems; track trackByTenantAlias($index, tenantMapping)) {
  <div [ngClass]="allowPageBreak ? 'sis-tenant-allow-page-break' : 'sis-tenant-avoid-page-break'">
    <ion-row>
      <ion-col
        class="sis-tenant-title"
        [ngStyle]="{ 'font-size': config?.tenantTitleFontSize,
                'color': config?.tenantTitleColor,
                'background': config?.tenantColor ? config?.tenantColor : config?.headerColor }"
      >
        {{ tenantMapping.displayedTenantAlias }}
      </ion-col>
    </ion-row>
    @if (tenantMapping.infotext) {
    <ion-row class="sis-infotext">
      <ion-col class="ion-no-padding">
        <div [innerHTML]="tenantMapping.infotext"></div>
      </ion-col>
    </ion-row>
    }
    <sis-webreport-meteo-desktop
      [tenantAlias]="tenantMapping.tenantAlias"
      [meteoInfos$]="webReportMeteoItems$"
      [config]="config"
      [activeSeasonByTenantAlias]="activeSeasonByTenantAlias"
    ></sis-webreport-meteo-desktop>
    @for (group of tenantMapping.liftsGroups; track group) { @if (group.titles?.length > 0) {
    <ion-row class="sis-category-title">
      <ion-col [ngStyle]="{ 'font-size': config?.assetTitleFontSize, 'color': config?.assetTitleColor }">
        @for (title of group.titles; track title; let isLast = $last) {
        <span>
          {{ title | translate }} @if (!isLast) {
          <span> / </span>
          }
        </span>
        }
      </ion-col>
    </ion-row>
    } @for (row of group.items; track row) {
    <ion-row class="sis-data-row">
      @for (item of row.rowItems; track trackByGuid($index, item); let index = $index) {
      <ion-col>
        @if (item) {
        <sis-sismedia-item
          [item]="item"
          [bigScreenMode]="true"
          [config]="config"
          [longestLabelLength]="row.longestLabelLengths[index]"
        >
        </sis-sismedia-item>
        }
      </ion-col>
      }
    </ion-row>
    } } @for (group of tenantMapping.slopesGroups; track group) { @if (group.titles?.length > 0) {
    <ion-row class="sis-category-title">
      <ion-col [ngStyle]="{ 'font-size': config?.assetTitleFontSize, 'color': config?.assetTitleColor }">
        @for (title of group.titles; track title; let isLast = $last) {
        <span>
          {{ title | translate }} @if (!isLast) {
          <span> / </span>
          }
        </span>
        }
      </ion-col>
    </ion-row>
    } @for (row of group.items; track row) {
    <ion-row class="sis-data-row">
      @for (item of row.rowItems; track item; let index = $index) {
      <ion-col>
        @if (item) {
        <sis-sismedia-item
          [item]="item"
          [bigScreenMode]="true"
          [config]="config"
          [longestLabelLength]="row.longestLabelLengths[index]"
        >
        </sis-sismedia-item>
        }
      </ion-col>
      }
    </ion-row>
    } } @for (group of tenantMapping.trailsGroups; track group) { @if (group.titles?.length > 0) {
    <ion-row class="sis-category-title">
      <ion-col [ngStyle]="{ 'font-size': config?.assetTitleFontSize, 'color': config?.assetTitleColor }">
        @for (title of group.titles; track title; let isLast = $last) {
        <span>
          {{ title | translate }} @if (!isLast) {
          <span> / </span>
          }
        </span>
        }
      </ion-col>
    </ion-row>
    } @for (row of group.items; track row) {
    <ion-row class="sis-data-row">
      @for (item of row.rowItems; track trackByGuid($index, item); let index = $index) {
      <ion-col>
        @if (item) {
        <sis-sismedia-item
          [item]="item"
          [bigScreenMode]="true"
          [config]="config"
          [longestLabelLength]="row.longestLabelLengths[index]"
        >
        </sis-sismedia-item>
        }
      </ion-col>
      }
    </ion-row>
    } } @for (group of tenantMapping.gastrosGroups; track group) { @if (group.titles?.length > 0) {
    <ion-row class="sis-category-title">
      <ion-col [ngStyle]="{ 'font-size': config?.assetTitleFontSize, 'color': config?.assetTitleColor }">
        @for (title of group.titles; track title; let isLast = $last) {
        <span>
          {{ title | translate }} @if (!isLast) {
          <span> / </span>
          }
        </span>
        }
      </ion-col>
    </ion-row>
    } @for (row of group.items; track row) {
    <ion-row class="sis-data-row">
      @for (item of row.rowItems; track item) {
      <ion-col>
        @if (item) {
        <sis-sismedia-item [item]="item" [bigScreenMode]="true"> </sis-sismedia-item>
        }
      </ion-col>
      }
    </ion-row>
    } } @for (group of tenantMapping.poisGroups; track group) { @if (group.titles?.length > 0) {
    <ion-row class="sis-category-title">
      <ion-col [ngStyle]="{ 'font-size': config?.assetTitleFontSize, 'color': config?.assetTitleColor }">
        @for (title of group.titles; track title; let isLast = $last) {
        <span>
          {{ title | translate }} @if (!isLast) {
          <span> / </span>
          }
        </span>
        }
      </ion-col>
    </ion-row>
    } @for (row of group.items; track row) {
    <ion-row class="sis-data-row">
      @for (item of row.rowItems; track item) {
      <ion-col>
        @if (item) {
        <sis-sismedia-item [item]="item" [bigScreenMode]="true"> </sis-sismedia-item>
        }
      </ion-col>
      }
    </ion-row>
    } }
    <ion-row style="height: 50px">
      <ion-col></ion-col>
    </ion-row>
  </div>
  } @if (showLegend) {
  <ion-row class="vertical-align-content sis-legend">
    <ion-col size="auto">
      <ion-icon name="sis-open" class="sis-statusicon sis-green"></ion-icon>
      {{ 'webreport.term.open' | translate }}
    </ion-col>
    <ion-col size="auto">
      <ion-icon name="sis-closed" class="sis-statusicon sis-red"></ion-icon>
      {{ 'webreport.term.closed' | translate }}
    </ion-col>
    <ion-col size="auto">
      <ion-icon name="sis-preparation" class="sis-statusicon sis-yellow"></ion-icon>
      {{ 'webreport.term.preparation' | translate }}
    </ion-col>
  </ion-row>
  }
  <ion-row class="sis-footer vertical-align-content">
    <ion-col>
      @if (showFooter) {
      <span> {{ alias }} </span>
      @if (websiteUrl || phone) {
      <span class="sis-padding"> | </span>
      } @if (websiteUrl) {
      <span>
        <a href="{{ websiteUrl }}" target="_blank">{{ websiteDisplayUrl }}</a>
      </span>
      <span class="sis-padding"> | </span>
      } @if (phone) {
      <span>
        <a href="tel:{{ phone }}">Tel. {{ phone }}</a>
      </span>
      } }
    </ion-col>
    <ion-col size="auto" class="sis-siscontrol">
      <img class="sis-siscontrol-image" src="assets/sis-logo/siscontrol-color.svg" /><span class="sis-padding">|</span
      ><a href="https://sisag.ch/produkte/siscontrol" target="_blank">sisag.ch</a><span class="sis-padding">|</span>©
      2026 SISAG AG
    </ion-col>
  </ion-row>
</ion-grid>
}

<!-- small screen -->
@if (!bigScreenMode && isMobileDataLoaded) {
<ion-grid [ngClass]="mobileStyleTenant ? 'sis-grid-small-tenant-style' : 'sis-grid-small-sisag-style'">
  <ion-row
    class="sis-category-title-small"
    [ngStyle]="mobileStyleTenant ? {
      'color': config?.tenantTitleColor,
      'background': config?.tenantColor,
      'border-bottom-color': config?.tenantTitleColor } : {}"
  >
    <ion-col>
      <a href="https://sisag.ch/produkte/siscontrol" class="sis-logo" target="_blank">
        <img src="assets/sis-logo/siscontrol-icon.svg" />
      </a>
      <span>{{ titleTranslationString | translate }}</span>
    </ion-col>
  </ion-row>
  @for (kvp of webReportItemsByCategory | keyvalue; track kvp) {
  <sis-webreport-mobile-category
    [items]="kvp.value"
    [category]="kvp.key"
    [itemsUpdated$]="webReport$"
    [config]="config"
    [mobileStyleTenant]="mobileStyleTenant"
    [ngStyle]="{'display': kvp.key === (selectedAssetCategory$ | async) ? 'block' : 'none' }"
  ></sis-webreport-mobile-category>
  }
  <sis-webreport-meteo-mobile
    [meteoInfos$]="webReportMeteoItems$"
    [config]="config"
    [mobileStyleTenant]="mobileStyleTenant"
    [activeSeasonByTenantAlias]="activeSeasonByTenantAlias"
    [ngStyle]="{'display': (selectedAssetCategory$ | async) === 6 ? 'block' : 'none' }"
  ></sis-webreport-meteo-mobile>
</ion-grid>
}

<!-- tab bar -->
@if (!bigScreenMode && isMobileDataLoaded) {
<ion-toolbar [ngClass]="mobileStyleTenant ? 'sis-webreport-toolbar-tenant-style' : 'sis-webreport-toolbar-sisag-style'">
  <ion-tab-bar
    [ngClass]="mobileStyleTenant ? 'sis-webreport-tab-bar-tenant-style' : 'sis-webreport-tab-bar-sisag-style'"
  >
    @if (hasLifts) {
    <ion-col (click)="assetCategorySelected('Lift')" class="sis-tab-col">
      <ion-icon
        name="sis-icon-ropeway"
        class="sis-category-icon"
        [ngClass]="selectedAssetCategory === 'Lift' ? 'sis-selected' : 'sis-not-selected'"
      ></ion-icon>
      <span class="sis-tab-span" [ngClass]="selectedAssetCategory === 'Lift' ? 'sis-selected': 'sis-not-selected'"
        >{{ 'webreport.assetCategoryLift' | translate }}</span
      >
    </ion-col>
    } @if (hasSlopes) {
    <ion-col (click)="assetCategorySelected('Slope')" class="sis-tab-col">
      <ion-icon
        name="sis-icon-slope"
        class="sis-category-icon"
        [ngClass]="selectedAssetCategory === 'Slope' ? 'sis-selected' : 'sis-not-selected'"
      ></ion-icon>
      <ion-label class="sis-tab-span" [ngClass]="selectedAssetCategory === 'Slope' ? 'sis-selected': 'sis-not-selected'"
        >{{ 'webreport.assetCategorySlope' | translate }}</ion-label
      >
    </ion-col>
    } @if (hasTrails) {
    <ion-col (click)="assetCategorySelected('Trail')" class="sis-tab-col">
      <ion-icon
        name="sis-icon-trail"
        class="sis-category-icon"
        [ngClass]="selectedAssetCategory === 'Trail' ? 'sis-selected' : 'sis-not-selected'"
      ></ion-icon>
      <ion-label class="sis-tab-span" [ngClass]="selectedAssetCategory === 'Trail' ? 'sis-selected': 'sis-not-selected'"
        >{{ 'webreport.assetCategoryTrail' | translate }}</ion-label
      >
    </ion-col>
    } @if (hasGastros) {
    <ion-col (click)="assetCategorySelected('Gastro')" class="sis-tab-col">
      <ion-icon
        name="sis-icon-gastro"
        class="sis-category-icon"
        [ngClass]="selectedAssetCategory === 'Gastro' ? 'sis-selected' : 'sis-not-selected'"
      ></ion-icon>
      <ion-label
        class="sis-tab-span"
        [ngClass]="selectedAssetCategory === 'Gastro' ? 'sis-selected': 'sis-not-selected'"
        >{{ 'webreport.assetCategoryGastro' | translate }}</ion-label
      >
    </ion-col>
    } @if (hasPois) {
    <ion-col (click)="assetCategorySelected('Poi')" class="sis-tab-col">
      <ion-icon
        name="sis-icon-poi"
        class="sis-category-icon"
        [ngClass]="selectedAssetCategory === 'Poi' ? 'sis-selected' : 'sis-not-selected'"
        style="font-size: 35px"
      ></ion-icon>
      <ion-label class="sis-tab-span" [ngClass]="selectedAssetCategory === 'Poi' ? 'sis-selected': 'sis-not-selected'"
        >{{ 'webreport.assetCategoryPoi' | translate }}</ion-label
      >
    </ion-col>
    } @if (showMeteo) {
    <ion-col (click)="assetCategorySelected('Meteo')" class="sis-tab-col">
      <ion-icon
        name="sis-icon-meteo"
        class="sis-category-icon"
        [ngClass]="selectedAssetCategory === 'Meteo' ? 'sis-selected' : 'sis-not-selected'"
      ></ion-icon>
      <ion-label class="sis-tab-span" [ngClass]="selectedAssetCategory === 'Meteo' ? 'sis-selected': 'sis-not-selected'"
        >{{ 'webreport.assetCategoryMeteo' | translate }}</ion-label
      >
    </ion-col>
    }
  </ion-tab-bar>
</ion-toolbar>
}
